import { Injectable } from '@angular/core';
import { ReactiveLogger } from '../../../services/logging/logger.service';
import { LogEntry } from '../../../services/logging/log-entry.model';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ServerUnavailableService {
  constructor(
    private logger: ReactiveLogger,
  ) { }

  feed() {
    return this.logger.log.map((logEntry: LogEntry) => logEntry.toString());
  }

  dumpEnvironment() {
    this.logger.debug(environment);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/errors/server-unavailable/server-unavailable.service.ts